import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import client from '../../../client';
import { useMessage } from 'app/shared-components/MessageUtils';
import { useTranslation } from 'react-i18next';
const ModalAddFuelBatch = ({ open, setOpen, containerTankId, onAdded }) => {
  const { t } = useTranslation('navigation');
  const showMessageUtil = useMessage();
  const [form, setForm] = useState({
    compacctnum: '',
    container_tank_id: containerTankId,
    quantity: '',
    price_per_unit: '',
    supplier: '',
    notes: '',
  });

  useEffect(() => {
    // Obtener compacctnum de localStorage
    try {
      const lSData = JSON.parse(localStorage.getItem('persist:root'));
      const userData = JSON.parse(lSData.loadz_auth).AuthReducer.user;
      setForm(f => ({ ...f, compacctnum: userData.company.compacctnum }));
    } catch (e) {}
  }, [open]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await client.post('/fuel-inventory/add-fuel-batch/', { ...form });
      if (onAdded) onAdded();
      setOpen(false);
    } catch (err) {
      let errorMessage = t('ERROR_ADDING_FUEL_BATCH');
      
      if (err.response && err.response.data) {
        if (err.response.data.message) {
          errorMessage = err.response.data.message;
          showMessageUtil(errorMessage, 'error');
        } else if (err.response.data.error) {
          errorMessage = err.response.data.error;
          showMessageUtil(errorMessage, 'error');
        } else if (typeof err.response.data === 'string') {
          errorMessage = err.response.data;
          showMessageUtil(errorMessage, 'error');
        }
      } else if (err.message) {
        errorMessage = err.message;
        showMessageUtil(errorMessage, 'error');
      }
      
      showMessageUtil(errorMessage, 'error');
    }
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>{t('ADD_FUEL_PURCHASE')}</DialogTitle>
      <DialogContent>
        <label>{t('QUANTITY')}</label>
        <TextField
          margin="normal"
          fullWidth
          name="quantity"
          value={form.quantity}
          onChange={handleChange}
          inputProps={{ style: { padding: '5px' } }}
        />
        <label>{t('PRICE_PER_UNIT')}</label>
        <TextField
          margin="normal"
          fullWidth
          name="price_per_unit"
          value={form.price_per_unit}
          onChange={handleChange}
          inputProps={{ style: { padding: '5px' } }}
        />
        <label>{t('SUPPLIER')}</label>
        <TextField
          margin="normal"
          fullWidth
          name="supplier"
          value={form.supplier}
          onChange={handleChange}
          inputProps={{ style: { padding: '5px' } }}
        />
        <label>{t('NOTES')}</label>
        <TextField
          margin="normal"
          fullWidth
          name="notes"
          value={form.notes}
          onChange={handleChange}
          inputProps={{ style: { padding: '5px' } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{t('CANCEL')}</Button>
        <Button onClick={handleSubmit} variant="contained">{t('ADD')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAddFuelBatch;
